import { render, staticRenderFns } from "./r-reward-package-config-dialog.vue?vue&type=template&id=35d9c8bc&scoped=true"
import script from "./r-reward-package-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-reward-package-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-reward-package-config-dialog.vue?vue&type=style&index=0&id=35d9c8bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9c8bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d9c8bc')) {
      api.createRecord('35d9c8bc', component.options)
    } else {
      api.reload('35d9c8bc', component.options)
    }
    module.hot.accept("./r-reward-package-config-dialog.vue?vue&type=template&id=35d9c8bc&scoped=true", function () {
      api.rerender('35d9c8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward-pack/r-reward-package-config-dialog.vue"
export default component.exports